
export default {
  emits: ['submit'],
  data() {
    return {
      name: '',
      name_valid: false,
      linkedin_id: '',
      linkedin_id_valid: false,
      website_url: '',
      website_url_valid: false,
      loading: false,
    }
  },
  computed: {
    can_submit() {
      return this.name_valid && this.linkedin_id_valid && this.website_url_valid
    }
  },
  methods: {
    open(){
      this.name = undefined
      this.linkedin_id = undefined
      this.website_url = undefined
      this.loading = false
      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close(force) {
      if (!force && this.loading) return
      this.$refs.modal.close()
    },
    submit() {
      this.loading = true
      this.$emit('submit', {
        name: this.name, 
        linkedin_id: this.linkedin_id,
        website_url: this.website_url
      })
    }
  }
}
